import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React__default from 'react';
import { UiComponentsProvider } from '../../ui-components-provider.js';
import { ROOT } from './data-hooks.js';
import { s as styleInject } from '../../style-inject.es-e7b07dd7.js';

var css_248z = ".mIgUg{--wds-side-panel-content-padding-vertical:0px}.U6D17{--wds-side-panel-footer-padding-vertical:18px}._0aCfW{height:100%}";
var classes = {"content":"mIgUg","footer":"U6D17","fullscreen":"_0aCfW"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FullscreenMobileLayout = ({
  onCloseButtonClick,
  dataHook,
  header,
  content,
  footer,
  sidePanelProps
}) => {
  return /* @__PURE__ */ React__default.createElement(UiComponentsProvider, null, /* @__PURE__ */ React__default.createElement(
    SidePanel,
    __spreadValues({
      onCloseButtonClick,
      height: "100vh",
      width: "100%",
      dataHook: classNames(ROOT, dataHook)
    }, sidePanelProps),
    header && /* @__PURE__ */ React__default.createElement(SidePanel.Header, __spreadValues({ showDivider: false }, header)),
    /* @__PURE__ */ React__default.createElement(SidePanel.Content, __spreadValues({ stretchVertically: true, className: classes.content }, content)),
    footer && /* @__PURE__ */ React__default.createElement(SidePanel.Footer, __spreadValues({ showDivider: true, className: classes.footer }, footer))
  ));
};

export { FullscreenMobileLayout };
//# sourceMappingURL=fullscreen-mobile-layout.js.map
